<template>
  <div class="recruiment-notice-detail">
    <div class="title-wrap">
      <div class="subtitle-wrap">
        <div class="title">{{ body.xRecruitmentplanname }}</div>
        <div class="icon">
          <my-icon
            :name="body.status == '1' ? '报名中' : '已截止'"
            :status="body.status"
          ></my-icon>
        </div>
      </div>
      <!-- <div class="pubdate-wrap">
        <div class="date"> <span>发布于：</span><span>{{body.releaseDate && moment(body.releaseDate).format('YYYY-MM-DD')}}</span></div>
      </div> -->
    </div>
    <div class="register-wrap">
      <div>
        <span>注册时间：</span
        ><span>
          {{
            body.releaseDate && moment(body.releaseDate).format('YYYY-MM-DD')
          }}至
          {{
            body.registerEndDate &&
              moment(body.registerEndDate).format('YYYY-MM-DD')
          }}
        </span>
      </div>
      <div>
        <span>开放注册公司：</span><span>{{ body.openRegRegions }}</span>
      </div>
    </div>
    <recruitTitle title="开放注册类型"></recruitTitle>
    <div class="reg-type-wrap">
      <div class="reg-type-header">
        <span>供应商类型</span>
        <span>注册资金(万元)</span>
        <span>注册开始时间</span>
        <span>注册截止时间</span>
      </div>
      <div class="reg-type-body">
        <div
          class="reg-type-item"
          v-for="item in providerTypes"
          :key="item.name"
        >
          <span>{{ item.name }}</span>
          <span>{{ item.regAmount }}</span>
          <span>{{
            item.regBeginDate && moment(item.regBeginDate).format('YYYY/MM/DD')
          }}</span>
          <span>{{
            item.regEndDate && moment(item.regEndDate).format('YYYY/MM/DD')
          }}</span>
        </div>
      </div>
      <div
        class="reg-type-footer"
        @click="handMore"
        v-if="providerTypesAll.length > 5"
      >
        {{ flag ? '查看更多' : '收起' }}
        <van-icon name="arrow-down" v-if="flag" style="top:2px" />
        <van-icon name="arrow-up" v-else style="top:2px" />
      </div>
    </div>
    <div class="detail">
      <recruitTitle title="招募详情"></recruitTitle>
      <div class="detail-rest ql-editor" v-html="body.xRemark"></div>
    </div>
    <div class="footer">
      报名请登录新希望招采平台：https://home.myyscm.com/xxwdc
    </div>
  </div>
</template>

<script>
import recruitTitle from './recruit-title';
import myIcon from './sing-up-status';
import moment from 'moment';
import { getUrlParams } from 'common/js/mUtils';
import { Icon } from 'vant';
export default {
  components: {
    recruitTitle,
    myIcon,
    'van-icon': Icon
  },
  data() {
    return {
      name: '报名中',
      body: {
        providerTypes: []
      },
      moment,
      flag: true,
      providerTypes: [],
      providerTypesAll: []
    };
  },
  created() {
    let { id } = getUrlParams();
    let { recruitGuid } = this.$route.query;
    if (!recruitGuid) {
      recruitGuid = id;
    }
    this.$api.getRecruitInfo({ recruitGuid }).then(res => {
      let { code, body } = res;
      if (code == '0000') {
        this.body = body;
        this.providerTypesAll = JSON.parse(JSON.stringify(body.providerTypes));
        this.providerTypesRest =
          body.providerTypes.length > 5 ? body.providerTypes.splice(5) : [];
        this.providerTypes =
          body.providerTypes.length > 5
            ? body.providerTypes.splic(0, 5)
            : body.providerTypes;
      }
    });
  },
  methods: {
    handMore() {
      let { flag, providerTypesRest, providerTypes } = this;
      if (flag) {
        this.providerTypes = providerTypes.concat(providerTypesRest);
      } else {
        this.providerTypes = providerTypes.splice(0, 5);
      }
      this.flag = !flag;
    }
  }
};
</script>

<style lang="scss" scoped>
$color-style-666: #666;
$color-style-333: #333;
$color-style-000: #000;
$font-size-26: 26px;
$font-size-28: 28px;
.recruiment-notice-detail {
  background: #efefef;
  .title-wrap {
    // height: 178px;
    border-bottom: #efefef 1px solid;
    padding: 32px;
    padding-right: 0px;
    background: #fff;
    .subtitle-wrap {
      display: flex;
      .title {
        flex: auto;
        padding-right: 10px;
        color: #000;
        font-size: 32px;
        font-weight: 500;
      }
      .icon {
        width: 120px;
        font-size: 22px;
        font-weight: 400;
        line-height: 2;
      }
    }
    .pubdate-wrap {
      font-size: $font-size-26;
      margin-top: 22px;
      display: flex;
      justify-content: space-between;
      .date {
        span:nth-child(1) {
          color: $color-style-666;
        }
        span:nth-child(2) {
          color: $color-style-333;
        }
      }
      .share-icon {
        padding-right: 20px;
      }
    }
  }
  .register-wrap {
    padding: 20px 32px;
    background: #fff;
    > div {
      line-height: 1.8;
      font-size: $font-size-26;
      span:nth-child(1) {
        color: $color-style-666;
      }
      span:nth-child(2) {
        color: $color-style-333;
      }
    }
    div:nth-child(2) {
      display: flex;
      span:nth-child(1) {
        width: 210px;
      }
      span:nth-child(2) {
        flex: 1;
      }
    }
  }
  .reg-type-wrap {
    background: #fff;
    // border: 1px solid rgba(238, 238, 238, 1);
    padding: 12px;
    .reg-type-header {
      background: rgba(240, 240, 240, 0.4);
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(238, 238, 238, 1);
      color: #666;
      font-size: 26px;
      span {
        flex: 1;
        padding: 24px 0px;
        text-align: center;
        border-right: 1px solid rgba(238, 238, 238, 1);
      }
    }
    .reg-type-item {
      // height: 68px;
      background: rgba(240, 240, 240, 0.4);
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(238, 238, 238, 1);
      color: #343434;
      font-size: 26px;
      span {
        flex: 1;
        text-align: center;
        position: relative;
        padding: 24px 0px;
      }
      span:after {
        position: absolute;
        right: 0px;
        top: 0px;
        height: 100%;
        width: 1px;
        content: '';
        background: rgba(238, 238, 238, 1);
      }
    }
    .reg-type-footer {
      text-align: center;
      padding: 12px 0px;
      padding-top: 24px;
    }
  }
  .detail {
    margin-top: 20px;
    background: #fff;
    .detail-rest {
      padding: 20px 50px 40px 32px;
      line-height: 1.5;
      .title {
        font-size: $font-size-28;
        margin-bottom: 30px;
      }
      .list {
        font-size: $font-size-26;
        margin-bottom: 20px;
        span:nth-child(1) {
          color: $color-style-666;
        }
        span:nth-child(2) {
          color: $color-style-000;
        }
      }
    }
  }
  .enclosure {
    margin-top: 20px;
  }
  .footer {
    background: #fff;
    padding: 20px;
    line-height: 1.5;
    padding-bottom: 40px;
  }
}
</style>
